/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import {Link} from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import {useSelector} from 'react-redux';
import {toAbsoluteUrl} from '../../../../_helpers';
import {DropdownTopbarItemToggler} from '../../../../_partials/dropdowns';

export function UserProfileDropdown() {
    const {user} = useSelector(state => state.auth);

    return (
        <Dropdown drop='down' alignRight>
            <Dropdown.Toggle
                as={DropdownTopbarItemToggler}
                id='dropdown-toggle-user-profile'>
                <div
                    className={
                        'btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2'
                    }>
					<span className='text-muted font-weight-bold font-size-base d-none d-md-inline mr-1'>
						Hi,
					</span>{' '}
                    <span className='text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3'>
						{user.name}
					</span>
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu
                className='p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-md'>
                <div
                    className='d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top'
                    style={{
                        backgroundImage: `url(${toAbsoluteUrl(
                            '/media/misc/bg-1.jpg'
                        )})`,
                    }}>
                    <div className='text-white m-0 flex-grow-1 mr-3 font-size-h5'>
                        {user.name}
                    </div>
                </div>

                <div className='navi navi-spacer-x-0 pt-5'>
                    <div className='navi-footer px-8 py-5'>
                        <Link
                            to='/logout'
                            className='btn btn-light-primary font-weight-bold'>
                            Đăng xuất
                        </Link>
                    </div>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}
